import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import widthMixin from '../../styles/utils/widthMixin';

interface IFieldsetProps {
  cols: any;
  minHeight?: number;
  collapsed?: boolean;
}

const flexBox = (props: IFieldsetProps) => {
  props.cols = { tablet: 1, mobile: 1, desktop: props.cols };
  return css`
    ${widthMixin};
  `;
};

const minHeight = (props: IFieldsetProps) => {
  if (props.minHeight != undefined && props.minHeight > 0) {
    return css`
      min-height: ${(props: any) => props.minHeight + 'px'};
    `;
  }
};

const Fieldset = styled.div<IFieldsetProps>`
  margin-bottom: 0;
  ${(props: IFieldsetProps) => minHeight(props)};
  ${(props: IFieldsetProps) => flexBox(props)};
`;

Fieldset.propTypes = {
  cols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minHeight: PropTypes.any,
  collapsed: PropTypes.bool,
};
Fieldset.defaultProps = {
  cols: 1,
  minHeight: 0,
  collapsed: false,
};
export default Fieldset;
